import React, { useState, useEffect } from "react";
import { firestore, storage } from "../../firebase-config";
import { v4 as uuidv4 } from "uuid";
import { doc, getDoc, setDoc, collection, getDocs } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import '../../styles/DepartmentDetailsAdmin.css';

import { deleteDoc, doc as firestoreDoc } from "firebase/firestore";
import { ref as storageRef, deleteObject } from "firebase/storage";
const AdminUpload = () => {
  const [departmentDetails, setDepartmentDetails] = useState({
        vision: "",
        mission: "",
        about: "",
        hodName: "",
        hodTalk: "",
        hodDesignation: "",
        hodQualification: "",
        hodInterests: "",
        hodExperience: 0,
        hodImageUrl: null,
        departmentPhotoUrl: null,
        hodImageFile: null,
        departmentPhotoFile: null,
      });

  const [facultyList, setFacultyList] = useState([]);
  const [nonFacultyList, setNonFacultyList] = useState([]);

  const deleteImage = async (imageUrl) => {
    if (!imageUrl) return;
    
    try {
      // Extract the path from the URL
      const urlPath = decodeURIComponent(imageUrl.split('/o/')[1].split('?')[0]);
      const imageRef = storageRef(storage, urlPath);
      await deleteObject(imageRef);
    } catch (error) {
      console.error("Error deleting image: ", error);
      throw new Error("Failed to delete image.");
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const electronicsEngineerDoc = doc(firestore, "electronics_engineer", "general");
        const docSnap = await getDoc(electronicsEngineerDoc);

        if (docSnap.exists()) {
          const data = docSnap.data();
          setDepartmentDetails({
            vision: data.vision || "",
            mission: data.mission || "",
            about: data.about || "",
            hodName: data.hodDetails?.name || "",
            hodTalk: data.hodDetails?.talk || "",
            hodDesignation: data.hodDetails?.designation || "",
            hodQualification: data.hodDetails?.qualification || "",
            hodInterests: data.hodDetails?.interests || "",
            hodExperience: data.hodDetails?.experience || 0,
            hodImageUrl: data.hodDetails?.imageUrl || null,
            departmentPhotoUrl: data.departmentPhotoUrl || null,
            hodImageFile: null,
            departmentPhotoFile: null,
          });

          // Fetch faculty details
          const facultySnapshot = await getDocs(collection(electronicsEngineerDoc, "faculty"));
          const facultyData = facultySnapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));
          setFacultyList(facultyData);

          // Fetch non-faculty details
          const nonFacultySnapshot = await getDocs(collection(electronicsEngineerDoc, "nonFaculty"));
          const nonFacultyData = nonFacultySnapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));
          setNonFacultyList(nonFacultyData);
        }
      } catch (error) {
        console.error("Error fetching data: ", error);
        alert("Error fetching data.");
      }
    };

    fetchData();
  }, []);

  

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setDepartmentDetails((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    setDepartmentDetails((prev) => ({ ...prev, [name]: files[0] }));
  };

  const updateList = (list, index, key, value, setList) => {
    const updatedList = [...list];
    updatedList[index][key] = value;
    setList(updatedList);
  };

  const addEntity = (setList, entityTemplate) => {
    setList((prev) => [...prev, entityTemplate]);
  };


  
  const uploadImage = async (file, folder) => {
    if (!file) return null;
    try {
      const imageRef = ref(storage, `electronics_engineer/${folder}/${uuidv4()}`);
      await uploadBytes(imageRef, file);
      return await getDownloadURL(imageRef);
    } catch (error) {
      console.error("Error uploading image: ", error);
      throw new Error("Failed to upload image.");
    }
  };

  

  const saveDepartmentDetails = async () => {
    try {
      const departmentPhotoUrl = departmentDetails.departmentPhotoFile
        ? await uploadImage(departmentDetails.departmentPhotoFile, "department_photos")
        : departmentDetails.departmentPhotoUrl;
  
      const hodImageUrl = departmentDetails.hodImageFile
        ? await uploadImage(departmentDetails.hodImageFile, "hod_images")
        : departmentDetails.hodImageUrl;
  
      const electronicsEngineerDoc = doc(firestore, "electronics_engineer", "general");
      await setDoc(electronicsEngineerDoc, {
        vision: departmentDetails.vision,
        mission: departmentDetails.mission,
        about: departmentDetails.about,
        hodDetails: {
          name: departmentDetails.hodName,
          talk: departmentDetails.hodTalk,
          designation: departmentDetails.hodDesignation,
          qualification: departmentDetails.hodQualification,
          interests: departmentDetails.hodInterests,
          experience: departmentDetails.hodExperience || 0,
          imageUrl: hodImageUrl || departmentDetails.hodImageUrl,
        },
        departmentPhotoUrl: departmentPhotoUrl || departmentDetails.departmentPhotoUrl,
      });
  
      // Save faculty details
      const facultyCollection = collection(electronicsEngineerDoc, "faculty");
      for (const faculty of facultyList) {
        if (faculty.imageFile) {
          const facultyImageUrl = await uploadImage(faculty.imageFile, "faculty_images");
          faculty.imageUrl = facultyImageUrl;
          delete faculty.imageFile;
        }
        faculty.experience = parseInt(faculty.experience) || 0;
        const facultyDoc = doc(facultyCollection, faculty.id || uuidv4());
        await setDoc(facultyDoc, faculty);
      }
  
      // Save non-faculty details
      const nonFacultyCollection = collection(electronicsEngineerDoc, "nonFaculty");
      for (const nonFaculty of nonFacultyList) {
        if (nonFaculty.imageFile) {
          const nonFacultyImageUrl = await uploadImage(nonFaculty.imageFile, "non_faculty_images");
          nonFaculty.imageUrl = nonFacultyImageUrl;
          delete nonFaculty.imageFile;
        }
        nonFaculty.experience = parseInt(nonFaculty.experience) || 0;
        console.log("Saving Non-Faculty Data:", nonFaculty);  // Log to check
        const nonFacultyDoc = doc(nonFacultyCollection, nonFaculty.id || uuidv4());
        await setDoc(nonFacultyDoc, nonFaculty);
      }
  
      alert("Data uploaded successfully!");
    } catch (error) {
      console.error("Error uploading data: ", error);
      alert("Error uploading data.");
    }
  };
  
  const deleteFaculty = async (faculty, index) => {
    try {
      // If the faculty has an ID (exists in Firestore), delete the document
      if (faculty.id) {
        const facultyDocRef = firestoreDoc(
          firestore, 
          "electronics_engineer", 
          "general", 
          "faculty", 
          faculty.id
        );
        await deleteDoc(facultyDocRef);
        
        // Delete the image from storage if it exists
        if (faculty.imageUrl) {
          await deleteImage(faculty.imageUrl);
        }
      }
      
      // Remove from local state
      const updatedList = [...facultyList];
      updatedList.splice(index, 1);
      setFacultyList(updatedList);
      
      alert("Faculty member deleted successfully!");
    } catch (error) {
      console.error("Error deleting faculty: ", error);
      alert("Error deleting faculty member.");
    }
  };
  
  const deleteNonFaculty = async (nonFaculty, index) => {
    try {
      // If the non-faculty has an ID (exists in Firestore), delete the document
      if (nonFaculty.id) {
        const nonFacultyDocRef = firestoreDoc(
          firestore, 
          "electronics_engineer", 
          "general", 
          "nonFaculty", 
          nonFaculty.id
        );
        await deleteDoc(nonFacultyDocRef);
        
        // Delete the image from storage if it exists
        if (nonFaculty.imageUrl) {
          await deleteImage(nonFaculty.imageUrl);
        }
      }
      
      // Remove from local state
      const updatedList = [...nonFacultyList];
      updatedList.splice(index, 1);
      setNonFacultyList(updatedList);
      
      alert("Non-faculty member deleted successfully!");
    } catch (error) {
      console.error("Error deleting non-faculty: ", error);
      alert("Error deleting non-faculty member.");
    }
  };
  

  return (
      <div className="department-details">
        <h1>Department of Electronics and Communication Upload</h1>
  
        {/* Department Details */}
        <div className="department-image1">
          {departmentDetails.departmentPhotoUrl && (
            <img
              src={departmentDetails.departmentPhotoUrl}
              alt="Department"
            />
          )}
          <input 
            type="file" 
            name="departmentPhotoFile" 
            onChange={handleFileChange}
          />
        </div>
  
        <div className="vision-mission">
          <div className="box">
            <input
              type="text"
              name="vision"
              placeholder="Vision"
              value={departmentDetails.vision}
              onChange={handleInputChange}
              className="w-full p-2 border rounded"
            />
          </div>
          <div className="box">
            <input
              type="text"
              name="mission"
              placeholder="Mission"
              value={departmentDetails.mission}
              onChange={handleInputChange}
              className="w-full p-2 border rounded"
            />
          </div>
        </div>
  
        <div className="about-department">
          <textarea
            name="about"
            placeholder="About"
            value={departmentDetails.about}
            onChange={handleInputChange}
            className="w-full p-2 border rounded h-32"
          ></textarea>
        </div>
  
 
  
        {/* HOD Details */}
        <h2>HOD Details</h2>
        <div className="hod-section">
          <div className="hod-left">
            <input
              type="text"
              name="hodName"
              placeholder="HOD Name"
              value={departmentDetails.hodName}
              onChange={handleInputChange}
              className="w-full p-2 border rounded mb-4"
            />
            <input
  type="text"
  name="hodDesignation"
  placeholder="HOD Designation"
  value={departmentDetails.hodDesignation}
  onChange={handleInputChange}
  className="w-full p-2 border rounded mb-4"
/>

            <input
              type="text"
              name="hodQualification"
              placeholder="HOD Qualification"
              value={departmentDetails.hodQualification}
              onChange={handleInputChange}
              className="w-full p-2 border rounded mb-4"
            />
            <input
  type="text"
  name="hodInterests"
  placeholder="HOD Interests"
  value={departmentDetails.hodInterests}
  onChange={handleInputChange}
  className="w-full p-2 border rounded mb-4"
/>
<input
  type="number"
  name="hodExperience"
  placeholder="Years of Experience"
  value={departmentDetails.hodExperience || 0}
  onChange={handleInputChange}
  className="w-full p-2 border rounded mb-4"
  min="0"
/>
            <textarea
              name="hodTalk"
              placeholder="HOD Talk"
              value={departmentDetails.hodTalk}
              onChange={handleInputChange}
              className="w-full p-2 border rounded h-32"
            ></textarea>
          </div>
          <div className="hod-right1">
            {departmentDetails.hodImageUrl && (
              <img
                src={departmentDetails.hodImageUrl}
                alt="HOD"
              />
            )}
            <input 
              type="file" 
              name="hodImageFile" 
              onChange={handleFileChange}
            />
          </div>
        </div>
  

  
        {/* Faculty Details */}
        <h2>Faculty Details</h2>
        <div className="faculty-list">
        {facultyList.map((faculty, index) => (
  <div key={faculty.id || index} className="faculty">
    <div className="faculty-image">
      {faculty.imageUrl && (
        <img
          src={faculty.imageUrl}
          alt="Faculty"
        />
      )}
      <input
        type="file"
        onChange={(e) =>
          updateList(facultyList, index, "imageFile", e.target.files[0], setFacultyList)
        }
      />
    </div>
    <div className="faculty-details">
      <input
        type="text"
        placeholder="Name"
        value={faculty.name || ""}
        onChange={(e) =>
          updateList(facultyList, index, "name", e.target.value, setFacultyList)
        }
        className="w-full p-2 border rounded mb-2"
      />
      <input
        type="text"
        placeholder="Designation"
        value={faculty.designation || ""}
        onChange={(e) =>
          updateList(facultyList, index, "designation", e.target.value, setFacultyList)
        }
        className="w-full p-2 border rounded mb-2"
      />
      <input
        type="text"
        placeholder="Qualification"
        value={faculty.qualification || ""}
        onChange={(e) =>
          updateList(facultyList, index, "qualification", e.target.value, setFacultyList)
        }
        className="w-full p-2 border rounded mb-2"
      />
      <input
  type="text"
  placeholder="Interests"
  value={faculty.interests || ""}
  onChange={(e) =>
    updateList(facultyList, index, "interests", e.target.value, setFacultyList)
  }
  className="w-full p-2 border rounded mb-2"
/>
<input
  type="number"
  placeholder="Years of Experience"
  value={faculty.experience || 0}
  onChange={(e) =>
    updateList(facultyList, index, "experience", parseInt(e.target.value) || 0, setFacultyList)
  }
  className="w-full p-2 border rounded"
  min="0"
/>
    </div>
    <div className="faculty-actions">
      <button
        onClick={() => deleteFaculty(faculty, index)}
        className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600"
      >
        Delete
      </button>
    </div>
  </div>
))}
        </div>
        <button
          onClick={() =>
            addEntity(setFacultyList, {
              id: uuidv4(),
              name: "",
              designation: "",
              qualification: "",
              interests: "",
              experience: 0,
              imageFile: null,
              imageUrl: null,
            })
          }
          className="mb-8 px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
        >
          Add Faculty
        </button>
  

  
        {/* Non-Faculty Details */}
        <h2>Non-Faculty Details</h2>
        <div className="non-faculty-list">
        {nonFacultyList.map((nonFaculty, index) => (
  <div key={nonFaculty.id || index} className="non-faculty">
    <div className="non-faculty-image">
      {nonFaculty.imageUrl && (
        <img
          src={nonFaculty.imageUrl}
          alt="Non-Faculty"
        />
      )}
      <input
        type="file"
        onChange={(e) =>
          updateList(nonFacultyList, index, "imageFile", e.target.files[0], setNonFacultyList)
        }
      />
    </div>
    <div className="non-faculty-details">
      <input
        type="text"
        placeholder="Name"
        value={nonFaculty.name || ""}
        onChange={(e) =>
          updateList(nonFacultyList, index, "name", e.target.value, setNonFacultyList)
        }
        className="w-full p-2 border rounded mb-2"
      />
      <input
        type="text"
        placeholder="Designation"
        value={nonFaculty.designation || ""}
        onChange={(e) =>
          updateList(nonFacultyList, index, "designation", e.target.value, setNonFacultyList)
        }
        className="w-full p-2 border rounded mb-2"
      />
      <input
        type="text"
        placeholder="Qualification"
        value={nonFaculty.qualification || ""}
        onChange={(e) =>
          updateList(nonFacultyList, index, "qualification", e.target.value, setNonFacultyList)
        }
        className="w-full p-2 border rounded mb-2"
      />
  <input
  type="text"
  placeholder="Interests"
  value={nonFaculty.interests || ""}
  onChange={(e) =>
    updateList(nonFacultyList, index, "interests", e.target.value, setNonFacultyList) // Fixed: was setFacultyList
  }
  className="w-full p-2 border rounded mb-2"
/>
<input
  type="number"
  placeholder="Years of Experience"
  value={nonFaculty.experience || 0}
  onChange={(e) =>
    updateList(nonFacultyList, index, "experience", parseInt(e.target.value) || 0, setNonFacultyList) // Fixed: was setFacultyList
  }
  className="w-full p-2 border rounded"
  min="0"
/>
    </div>
    <div className="non-faculty-actions">
      <button
        onClick={() => deleteNonFaculty(nonFaculty, index)}
        className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600"
      >
        Delete
      </button>
    </div>
  </div>
))}
        </div>
        <button
          onClick={() =>
            addEntity(setNonFacultyList, {
              id: uuidv4(),
              name: "",
              designation: "",
              qualification: "",
              interests: "",
              imageFile: null,
              imageUrl: null,
            })
          }
          className="mb-8 px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
        >
          Add Non-Faculty
        </button>
  
        {/* Save Button */}
        <button 
          onClick={saveDepartmentDetails}
          className="w-full px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600"
        >
          Save Details
        </button>
      </div>
        );
};

export default AdminUpload;
